import { Component, Input } from '@angular/core';

@Component({
  selector: 'nns-share-item',
  styles: [`
    .nns-logo-wrapper{
      max-width: 1600px;
      min-width: 320px;
      margin: 0 auto;
      padding: 0 10px;
      padding-top: 10px;
      box-sizing: border-box;
      display: flex;
      width: 100%;
    }
    .nns-logo-wrapper__center{
      justify-content: center;
    }
    .nns-logo-wrapper__right{
      justify-content: flex-end;
    }
    .nns-logo-wrapper__folder::before{
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
    :host {
      -ms-flex:1;
      box-sizing: border-box;
      display: flex;
      flex: 1 1 0;
      -ms-flex-direction: column;
      flex-direction: column;
    }

    :host-context(.nns-theme-night) .nns-logo-wrapper__folder::before{
      display: none;
    }

    @media only screen and (max-width: 768px) {
      .nns-logo-wrapper{
        justify-content: center;
      }
    }
    `],
  template: `
    <div class="nns-logo-wrapper"
      *ngIf="branding && branding.sharesLogoStoredFileUUID && branding.sharesLogoStoredFileUUID != null && !branding.sharesTopbar && !visual.isEmbed"
      [ngClass]="{
        'nns-logo-wrapper__center': branding.sharesLogoPosition == 'center',
        'nns-logo-wrapper__right': branding.sharesLogoPosition == 'right',
        'nns-logo-wrapper__folder': note?.type =='folder'
      }">
      <nns-branding-logo
        [sharesLogo]="branding.sharesLogoStoredFileUUID"
        [sharesLogoLink]="branding.sharesLogoLink"
        [visual]="visual"
        ></nns-branding-logo>
    </div>
    <nns-share-note flex layout="column"
      *ngIf="note?.type =='note'"
      [note]="note"
      [text]="text"
      [todos]="todos"
      [attachments]="attachments"
      [workspaces]="workspaces"
      [currentNoteWorkspace]="currentNoteWorkspace"
      [login]="login"
      [share]="share"
      [visual]="visual"
      [preview]="preview"
      [shareCopy]="shareCopy"
      [branding]="branding"
      [profile]="profile"
      [outlines]="outlines"
    ></nns-share-note>
    <nns-share-folder flex layout="column"
      *ngIf="note?.type =='folder'"
      [children]="children"
      [folder]="note"
      [login]="login"
      [share]="share"
      [shareCopy]="shareCopy"
      [visual]="visual"
      [isPending]="isPending"
      [branding]="branding"
      [profile]="profile"
    ></nns-share-folder>
  `,
})
export class ShareItemComponent {
  @Input() attachments;
  @Input() workspaces;
  @Input() currentNoteWorkspace;
  @Input() children;
  @Input() note;
  @Input() preview;
  @Input() login;
  @Input() share;
  @Input() shareCopy;
  @Input() text;
  @Input() todos;
  @Input() visual;
  @Input() isPending;
  @Input() branding;
  @Input() profile;
  @Input() outlines;
}
